import { render, staticRenderFns } from "./SelectClientsList.vue?vue&type=template&id=53b6bad4&"
import script from "./SelectClientsList.vue?vue&type=script&lang=js&"
export * from "./SelectClientsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports